import { gql } from "@apollo/client";

export const SEND_INITIATIVE_INVITE = gql`
  mutation Mutation($data: InviteToInitiativeInputData!) {
    iniviteToInitiative(data: $data) {
      id
      initiativeId
      invitedOrganizationId
      status
      createdAt
      initiative {
        name
      }
    }
  }
`;
